export default "__VITE_ASSET__Cn2XMDks__"